import styled from "styled-components";
import { UI_BODY_SEMIBOLD_SM_DF, UI_CAPTION_DF, UI_STAT_LG, colors2 } from "oolib";

export const StyledStatCardGroup = styled.div`
  display: flex;
  border-radius: 1.2rem;
  border: 1px solid ${colors2.grey10};
  background: ${colors2.white};
  overflow: hidden;
  box-shadow: 0px 4px 40px 0px #0000000A;

  & > *:last-child {
    border-right: none;
  }
`;

export const StyledStatCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding: 2rem;
  background: ${colors2.white};
  border-right: 1px solid ${colors2.grey10};
  flex: 1;
  position: relative;
  isolation: isolate;
`;

export const StyledProgressFill = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: calc(var(--progress) * 1%);
  background: linear-gradient(180deg, rgba(0, 119, 255, 0.13) 0%, rgba(0, 81, 255, 0.0286) 100%);
  z-index: -1;
  transition: height 0.3s ease;
`;

export const StyledTextGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledValue = styled(UI_STAT_LG)`
  font-weight: 700;
  line-height: 31px;
  color: ${colors2.grey80};
`;

export const StyledTitle = styled(UI_BODY_SEMIBOLD_SM_DF)`
  color: ${colors2.grey60};
`;

export const StyledSubline = styled(UI_CAPTION_DF)`
  color: ${colors2.grey60};
  margin-top: 0.4rem;
  font-variant-numeric: tabular-nums;
`;
